import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import s from './Title.module.scss';

type TitleProps = {
  size?: 'base' | 'xl' | '2xl';
  className?: string;
  order?: 1 | 2 | 3 | 4 | 5 | 6;
  children: React.ReactNode;
}

const Title = (props: TitleProps) => {
  const {
    size = 'base',
    order = 3,
    className = '',
    children,
  } = props;
  const HeadingTag = `h${order}`;

  return (
    // @ts-ignore
    <HeadingTag className={cx({
      'text-base': size === 'base',
      'text-xl': size === 'xl',
      'text-2xl': size === '2xl',
    }, 'font-medium', className)}>
      {children}
    </HeadingTag>
  );
}

export default Title;
